module.exports = __webpack_public_path__ + "af10f66ed7dcf65d515e6b54ebf89aa1.mp4";